import {Validators} from '@angular/forms';

import * as moment from 'moment';

import {MinDateValidator, OnlyDigitsValidator, WhitespaceValidator} from '@spa/validators';

import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components';
import {BaseControl, CheckboxControl, DatepickerControl, SelectControl} from '../../../app/shared/classes';

import {IdentityDocumentNumberMaxLength} from './identity-details-component.descriptor';

export const AddDocumentTypeSelector = 'documentType';
export const AddDocumentSubTypeSelector = 'documentSubType';
export const AddDocumentNumberSelector = 'documentNumber';
export const AddDocumentExpirationDateSelector = 'expirationDate';
export const AddDocumentNoteSelector = 'note';
export const AddDocumentSetAsVerifiedSelector = 'setAsVerified';
export const AddDocumentSetAsVisibleSelector = 'setAsVisible';

export const AddDocumentMaxNoteLength = 256;

export const AddDocumentControls = (): BaseControl<string | number | boolean>[] => {
    return [
        new SelectControl({
            name: AddDocumentTypeSelector,
            value: null,
            placeholder: 'Document type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
        }),
        new SelectControl({
            name: AddDocumentSubTypeSelector,
            value: null,
            placeholder: 'Document sub type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
        }),
        new BaseControl({
            name: AddDocumentNumberSelector,
            value: null,
            placeholder: 'Document number',
            validators: [WhitespaceValidator(), OnlyDigitsValidator(), Validators.maxLength(IdentityDocumentNumberMaxLength)],
            componentType: ComponentTypesEnum.Text
        }),
        new DatepickerControl({
            name: AddDocumentExpirationDateSelector,
            value: null,
            placeholder: 'Expiration date',
            minDate: moment().format('YYYY-MM-DD'),
            validators: [MinDateValidator(moment().format('YYYY-MM-DD'))],
            componentType: ComponentTypesEnum.LockableDatepicker,
            more: {
                texts: ['Non-expiring', 'Expiring']
            }
        }),
        new BaseControl({
            name: AddDocumentNoteSelector,
            value: '',
            placeholder: 'Note',
            validators: [],
            componentType: ComponentTypesEnum.Textarea
        }),
        new CheckboxControl({
            name: AddDocumentSetAsVerifiedSelector,
            value: false,
            placeholder: 'Set as active',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            checked: false,
            color: ColorCodesEnum.Primary,
            expectBooleanValue: true
        }),
        new CheckboxControl({
            name: AddDocumentSetAsVisibleSelector,
            value: false,
            placeholder: 'Set as visible for client',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            checked: false,
            color: ColorCodesEnum.Primary,
            expectBooleanValue: true
        }),
    ];
};

export const AddDocumentDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: 'Document creation failed.',
            succeedMessage: 'Document is successfully created.'
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Create
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
